import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useState } from "react";
import { retryTransaction } from "services";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { requestWithNotify } from "utils";

const RETRY_TX_DELAY = 1000;
export const RetryTransactionBtn = observer(() => {
  const { bidCard } = useStores();
  const { id } = bidCard.bid;
  const { openNotification } = useNotificationContext();
  const [loading, setLoading] = useState(false);

  const retryTransactionHandler = async () => {
    try {
      setLoading(true);
      const res = await requestWithNotify({
        fetchFn: () => retryTransaction(id),
        openNotification: openNotification,
        successMsg: "Инициирована повторная отправка ЦВ",
      });
      if (res.result) {
        await requestWithNotify({
          fetchFn: () => bidCard.updateCardById(id),
          openNotification: openNotification,
          delay: RETRY_TX_DELAY,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomButton onClick={retryTransactionHandler} loading={loading} disabled={loading}>
      Повторить транзакцию
    </CustomButton>
  );
});
